export default __webpack_public_path__ + "static/media/phone.95dcbde6.svg";